'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadl';
var iconName = 'hand';
var width = 512;
var height = 512;
var aliases = [129306,9995,"hand-paper"];
var unicode = 'f256';
var svgPathData = ['M39.5 279c-9.4 9.4-9.4 24.6 0 33.9L143.3 416.7C183.8 457.2 238.7 480 296 480l8.5 0c79.5 0 144-64.5 144-144l0-184c0-13.3-10.7-24-24-24-13.2 0-24 10.7-24 23.9l0 88.1c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-152c0-13.3-10.7-24-24-24-13.2 0-24 10.7-24 23.9l0 152.1c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-184c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 184c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-151.9c0-13.3-10.7-24.1-24-24.1s-24 10.7-24 24l0 239.4c0 6.5-3.9 12.3-9.9 14.8s-12.9 1.1-17.4-3.5L73.5 279c-9.4-9.4-24.6-9.4-33.9 0z', 'M264.5 0c-24.9 0-46 16.3-53.3 38.8-7.9-4.3-17-6.8-26.7-6.8-30.9 0-56 25.1-56 56l0 200.8-32.4-32.4c-21.9-21.9-57.3-21.9-79.2 0s-21.9 57.3 0 79.2L120.7 439.4C167.2 485.9 230.3 512 296 512l8.5 0c97.2 0 176-78.8 176-176l0-184c0-30.9-25.1-56-56-56-8.6 0-16.7 1.9-24 5.4l0-13.4c0-30.9-25.1-56-56-56-9.7 0-18.8 2.5-26.7 6.8-7.3-22.5-28.4-38.8-53.3-38.8zm-80 64c13.3 0 24 10.7 24 24l0 152c0 8.8 7.2 16 16 16s16-7.2 16-16l0-184c0-13.3 10.7-24 24-24s24 10.7 24 24l0 184c0 8.8 7.2 16 16 16s16-7.2 16-16l0-152.1c0-13.2 10.8-23.9 24-23.9 13.3 0 24 10.7 24 24l0 152c0 8.8 7.2 16 16 16s16-7.2 16-16l0-88.1c0-13.2 10.8-23.9 24-23.9 13.3 0 24 10.7 24 24l0 184c0 79.5-64.5 144-144 144l-8.5 0c-57.3 0-112.2-22.8-152.7-63.3L39.5 313c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l59.7 59.7c4.6 4.6 11.5 5.9 17.4 3.5s9.9-8.3 9.9-14.8l0-239.4c0-13.3 10.7-24 24-24z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faHand = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;